<template>
  <div>
    <v-style>
      .certification-create .modal-body {
        height: {{modalHeight}};
        transition: height 0.2s;
        overflow-y: unset !important;
      }
    </v-style>
    <CModal
      :show.sync="activeDelete"
      v-if="activeDelete"
      centered
      :draggable="false"
    >
      <template slot="header-wrapper">
        <div/>
      </template>
      Etes-vous sûr de vouloir supprimer {{activeDelete.certification_name}} ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = null">
          Non
        </CButton>
        <CButton
          color="primary"
          @click="deleteCert"
          data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
    <ReferenceTableActions
      table-name="certification"
      :buttons="['create', 'export']"
      @create="showCreate"
      @export="downloadFile({
          downloadURL: CERTIFICATION_ENDPOINTS.export,
          query: $refs.certsTable.tableQuery
        })"
    />
    <table-component
      :columns="tableColumns"
      :headings="tableHeadings"
      :url="CERTIFICATION_ENDPOINTS.base"
      :pagination-text-position="'bottom'"
      :init-filters="filters"
      ref="certsTable"
    >
      <template slot="level" slot-scope="{ row }">
        {{ row.level }}
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-wrap" style="row-gap: 0.25em; column-gap: 0.5em">
          <CButton
            class="sm outline action-button"
            color="primary"
            size="sm"
            variant="outline"
            @click="showEdit(row)"
          >
            <em class="fa fa-edit"/>
            Modifier
          </CButton>
          <CButton
            class="action-button"
            color="danger"
            size="sm"
            @click="activeDelete = row"
            data-cy="delete-button"
          >
            <em class="fa fa-close"/>
            Supprimer
          </CButton>
        </div>
      </template>
    </table-component>
    <CModal
      :show.sync="showModal"
      :draggable="false"
      :resizable="false"
      class="certification-create"
      centered
    >
      <template slot="header">
        {{isEdit ? "Modification d'une certification" : "Création d'une nouvelle certification"}}
      </template>
      <div class="d-flex flex-column gap-2 cert-modal">
        <div class="bg-extended-color44 p-2" v-if="alertMessage">
          {{ alertMessage }}
        </div>
        <CInput
          class="danger"
          required
          label="Certification Code"
          :disabled="isEdit"
          v-model="newCert.certification_code"
        />
        <CInput
          label="Titre / Diplôme"
          required
          v-model="newCert.certification_name"
        />
        <MzSelect
          label="Type"
          allow-unselect
          :options="certificationTypeOptions"
          :value.sync="newCert.certification_type"
          @show="setModalHeight(430)"
          @hide="setModalHeight(350)"
        />
        <CInput
          label="Label"
          v-model="newCert.label"
        />
        <CInput
          type="number"
          label="Niveau"
          v-model="newCert.level"
        />
      </div>
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showModal=false; oldCode = null"
          >
            Annuler
          </CButton>
          <CButton
            color="primary"
            :disabled="!!alertMessage"
            @click="isEdit ? updateCert() : createCert()"
          >
            {{isEdit ? "Sauvegarder" : "Créer une certification"}}
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import ReferenceTableActions from "@/components/ReferenceTableActions";
import {CERTIFICATION_ENDPOINTS, CertService} from "@/services/certification";
import {downloadFile} from "@/utils/request";

export default {
  name: "Certifications",
  components: {
    ReferenceTableActions
  },
  watch: {
    newCert: {
      handler() {
        this.alertMessage = ""
      },
      deep: true,
    }
  },
  data() {
    return {
      alertMessage: "",
      CERTIFICATION_ENDPOINTS,
      tableColumns: [
        "certification_code",
        "certification_name",
        "certification_type",
        "label",
        "level",
        "actions",
      ],
      modalHeight: 350,
      tableHeadings: {
        "certification_code": "Certification Code",
        "certification_name": "Titre / Diplôme",
        "certification_type": "Type",
        "level": "Niveau",
      },
      showModal: false,
      clearCert: {
        certification_code: "",
        certification_name: "",
        level: "",
      },
      certificationTypeOptions: [],
      filters: {},
      newCert: {},
      activeDelete: null,
      isEdit: null,
      oldCode: null,
    }
  },
  async mounted() {
    this.newCert = this.clearCert;
    this.certificationTypeOptions = await CertService.getTypes();
  },
  computed: {
    mandatoryFilled() {
        return !!this.newCert.certification_code?.replace(/ /g, "") &&
            !!this.newCert.certification_name?.replace(/ /g, "")
    }
  },
  methods: {
    downloadFile,
    async refreshTableData() {
      await this.$refs.certsTable.$refs.table.getData()
    },
    setModalHeight(height){
      this.modalHeight = `${height}px`
    },
    async createCert() {
      this.saveFilters();
      await this.checkIfInputCorrect()
      if (!!this.alertMessage) return
      const {res} = await CertService.createCert({
        certification_code: this.newCert.certification_code,
        certification_name: this.newCert.certification_name,
        certification_type: this.newCert.certification_type,
        label: this.newCert.label,
        level: this.newCert.level,
      });
      if (res.status !== 201) alert("Something went wrong")
      else {
        this.showModal = false;
        await this.refreshTableData()
      }
      this.newCert = this.clearCert;
    },
    async checkIfInputCorrect() {
      const {data, res} = await CertService.checkCode(this.newCert.certification_code);
      if (
        data &&
        !(this.oldCode === this.newCert.certification_code) &&
        res.status === 200
      ) this.alertMessage = "Certification with provided code already exists!";
      else if (!this.mandatoryFilled) this.alertMessage = 'Required fields are missing!'
      else this.alertMessage = ""
    },
    saveFilters() {
      this.filters = {};
      Object.entries(this.$refs.certsTable.tableQuery).forEach((filter) => {
        if (!["byColumn", "order_by", "page", "per_page"].includes(filter[0])) {
          this.filters[filter[0]] = filter[1];
        }
      });
    },
    async updateCert() {
      this.saveFilters();
      await this.checkIfInputCorrect()
      if (!!this.alertMessage) return
      const {res} = await CertService.updateCert(this.isEdit, {
        certification_code: this.newCert.certification_code,
        certification_name: this.newCert.certification_name,
        certification_type: this.newCert.certification_type,
        label: this.newCert.label,
        level: this.newCert.level,
      });
      if (res.status !== 200) alert("Something went wrong");
      this.isEdit = null;
      this.newCert = this.clearCert;
      this.showModal = false;
      this.oldCode = null
      await this.refreshTableData()
    },
    async deleteCert() {
      this.saveFilters();
      const {res} = await CertService.deleteCert(this.activeDelete._id);
      if (res.status !== 200) alert("Something went wrong");
      this.activeDelete = null;
      await this.$refs.certsTable.$refs.table.getData()
    },
    showCreate() {
      this.isEdit = false;
      this.newCert = {};
      this.showModal = true;
    },
    showEdit(cert) {
      this.oldCode = cert.certification_code;
      this.isEdit = cert._id;
      this.newCert = {...cert};
      this.showModal = true;
    },
  }
}
</script>
